import locationBirthplaceModelValidator from 'forms/shared/validators/models/location/models/birthplace';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import pvqNameModelValidator, { hasNameDetails } from 'forms/shared/validators/models/pvqName/name';
import { isPVQForm } from 'helpers/form';
import { IdentificationPlaceOfBirthModel } from './types';

const identificationPlaceOfBirthValidator: ValidateJSModel<IdentificationPlaceOfBirthModel> = {
  Location: (value, attributes, attributeName, options) => ({
    presence: true,
    location: {
      validator: locationBirthplaceModelValidator,
      requireCity: value ? !value.county : true,
      requireCounty: value ? !value.city : true,
    },
  }),

  MothersNameAtHerBirth: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.Location?.inUSA === true) {
      return {
        presence: true,
        model: { validator: pvqNameModelValidator },
      };
    }

    return {};
  },

  MothersNameAtYourBirth: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.Location?.inUSA === true && hasNameDetails(value)) {
      return {
        presence: true,
        model: { validator: pvqNameModelValidator },
      };
    }

    return {};
  },
};

export default identificationPlaceOfBirthValidator;
